<script setup lang="ts">
import SectionStepsView from 'modules/Section/views/SectionStepsView/SectionStepsView.vue';
import { useRepo } from 'pinia-orm';
import { UserSection } from 'src/modules/Section/models/UserSection';
import { ref, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
import { useUserCourseData } from '../../useUserCourseData';
import BPage from 'src/shared/components/base/BPage/BPage.vue';

const userSectionRepo = useRepo(UserSection);

// interface Props {
//   // modelValue: string
// }

// defineProps<Props>()
const route = useRoute();
const {
  params: { userSectionId, userCourseDocId },
} = route;

const { getUserSectionData } = useUserCourseData({
  userCourseDocId: userCourseDocId as string,
});

const userSectionDocId = ref('');

watchEffect(() => {
  if (typeof userSectionId !== 'string' || isNaN(+userSectionId)) {
    userSectionDocId.value = '';
    return;
  }

  const userSection = userSectionRepo?.find(+userSectionId)
    ?.documentId as string;
  if (!userSection) {
    // Handle async operation outside of watchEffect
    getUserSectionData(+userSectionId)
      .then(() => {
        userSectionDocId.value =
          userSectionRepo?.find(+userSectionId)?.documentId || '';
      })
      .catch((error) => {
        console.error('Error fetching user section data:', error);
        userSectionDocId.value = '';
      });
  } else {
    userSectionDocId.value = userSection;
  }
});
</script>

<template>
  <BPage>
    <div
      v-if="userSectionDocId"
      class="col fit overflow-auto"
    >
      <SectionStepsView
        :user-section-doc-id="userSectionDocId"
        :user-course-doc-id="userCourseDocId as string"
      />
    </div>
  </BPage>
</template>
